export function getProfilePageSchema({ name, description, image }) {
  return {
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name,
      description,
      image,
    },
  };
}
